import { IBaseResponse, IListDataResponseCanvas } from '~/utils/interface/base';
import axiosClient from './axiosClient';
import { ContentTypeEnum } from '~/utils/enum/common';
import { IModuleDetail, IQueryGetModule, UpsertModuleWatchProgressBody } from '~/utils/interface/module';
import { baseURL } from '~/utils/constants/env';
import { StorageEnum } from '~/utils/enum/base';
import { urlApiModule } from '~/utils/constants/apis';
import { IBodyAdminUpdateModuleWatchProgress } from '~/utils/interface/studentProgress';

const toAbsoluteUrl = (url: string) => {
  if (/^https?:\/\//i.test(url)) return url;
  const base = baseURL || (typeof window !== 'undefined' ? window.location.origin : '');
  if (!base) return url;
  return url.startsWith('/') ? `${base}${url}` : `${base}/${url}`;
};

export const moduleApi = {
  upsertModuleWatchProgress(moduleId: number, body: UpsertModuleWatchProgressBody) {
    return axiosClient.post<IBaseResponse<any>>(`/modules/${moduleId}/progress`, body, {
      headers: { 'Content-Type': ContentTypeEnum.JSON },
    });
  },

  upsertModuleWatchProgressBeacon(moduleId: number, body: UpsertModuleWatchProgressBody) {
    try {
      const url = toAbsoluteUrl(`/modules/${moduleId}/progress`);
      const token = typeof window !== 'undefined' ? localStorage.getItem(StorageEnum.ACCESS_TOKEN) : null;

      if (typeof window !== 'undefined' && 'fetch' in window) {
        const fetchOptions: RequestInit = {
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': ContentTypeEnum.JSON as string,
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          keepalive: true,
        };

        fetch(url, fetchOptions).catch(() => {});
        return true;
      }

      void axiosClient.post(`/modules/${moduleId}/progress`, body, {
        headers: { 'Content-Type': ContentTypeEnum.JSON },
        timeout: 2000,
      });
      return true;
    } catch {
      return false;
    }
  },

  getModules(params: IQueryGetModule) {
    const url = `${urlApiModule.base}`;
    return axiosClient.get<IBaseResponse<IListDataResponseCanvas<IModuleDetail[]>>>(url, { params });
  },

  adminUpdateModuleWatchProgress(moduleId: string, body: IBodyAdminUpdateModuleWatchProgress) {
    const url = urlApiModule.adminUpdateWatchProgress(moduleId);
    return axiosClient.put<IBaseResponse<any>>(url, body, {
      headers: { 'Content-Type': ContentTypeEnum.JSON },
    });
  },
};
